module.exports = {
  checkBool: (val) => {
    if (typeof value === 'string') {
      if (val.toLowerCase() === 'true') return true
      if (val.toLowerCase() === 'false') return false
    }
    return val
  },
  money: (val) => {
    return val.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
  },
  grant: () => {
    return (parseInt(window.localStorage.getItem('it.clubhub.grant'), 10) > 1)
  },
  grantAdmin: () => {
    return (parseInt(window.localStorage.getItem('it.clubhub.grant'), 10) === 5)
  },
  grantMy: (id) => {
    return (parseInt(window.localStorage.getItem('it.clubhub.userid'), 10) === id)
  },
  generateUrl: (prod, base, id, checksum) => {
    if (prod) {
      return base + '/' + id + '/' + checksum + '/'
    } else {
      return base + '?id=' + id + '&checksum=' + checksum
    }
  },
  validMail: (email) => {
    const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }
}



// WEBPACK FOOTER //
// ./src/components/Utils/Service.js